export default function last(array) {
    if (array) {
        return array[array.length - 1];
    }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/util/last.js
// module id = 1336
// module chunks = 0